/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum SSRV2RuleOrderValue {
    BrandAndMarket = 'BrandAndMarket',
    Description = 'Description',
    Suppliers = 'Suppliers',
    ContactEmail = 'ContactEmail',
    ContactMobile = 'ContactMobile'
}

export function SSRV2RuleOrderValueFromJSON(json: any): SSRV2RuleOrderValue {
    return SSRV2RuleOrderValueFromJSONTyped(json, false);
}

export function SSRV2RuleOrderValueFromJSONTyped(json: any, ignoreDiscriminator: boolean): SSRV2RuleOrderValue {
    return json as SSRV2RuleOrderValue;
}

export function SSRV2RuleOrderValueToJSON(value?: SSRV2RuleOrderValue | null): any {
    return value as any;
}

